import React, { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { toast } from 'react-toastify'
import { Hero } from 'components/Hero/Hero'
import { SponsorLogoBanner } from 'components/SponsorLogoBanner/SponsorLogoBanner'
import { OurGoals } from 'components/OurGoals/OurGoals'

interface LocationState {
  success?: string
  error?: string
}

export const HomePage: React.FC = () => {
  const location = useLocation()
  const state = location.state as LocationState

  useEffect(() => {
    // Show success toast if present
    if (state?.success) {
      toast.success(state.success, {
        position: 'top-right',
        autoClose: 8000, // Show longer for important messages
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true
      })
    }

    // Show error toast if present
    if (state?.error) {
      toast.error(state.error, {
        position: 'top-right',
        autoClose: 10000, // Show longer for error messages
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true
      })
    }

    // Clear the state after showing the toast to prevent re-showing on refresh
    if (state?.success || state?.error) {
      window.history.replaceState({}, document.title)
    }
  }, [state])

  return (
    <main className="min-h-screen">
      <Hero />
      <SponsorLogoBanner className="bg-[#3C2416]" />
      <OurGoals />
    </main>
  )
}

export default HomePage
